// /league/raceprogram/ で使用 => ページ非公開中

export default () => {

  const s = {}
  const init = () => {
    s.root = document.querySelector('.le-side-date');
    if (!s.root) {
      return;
    }
    console.log('init sidabar-date');

    buildSlider();
  }

  const buildSlider = () => {
    s.isSp = window.matchMedia('(max-width: 768px)').matches;

    s.dateList = s.root.querySelector('.le-side-date__list');
    s.settings = {
      clientLength: (s.isSp ? 'clientWidth' : 'clientHeight'),
      entityLength: (s.isSp ? 'scrollWidth' : 'clientHeight'),
      offsetLength: (s.isSp ? 'offsetWidth' :'offsetHeight'),
      offsetPos: (s.isSp ? 'offsetLeft' : 'offsetTop'),
      translateParam: (s.isSp ? 'left' : 'top')
    }

    if (s.root[s.settings.clientLength] >= s.dateList[s.settings.entityLength]) {
      s.root.classList.add('is-no-controller');
      return;
    }
    s.isSlide = true;
    s.translateDir = 'up';
    s.dateList.style.left = `0px`;

    s.translateQuantity = s.dateList.firstElementChild[s.settings.offsetLength];
    s.addTranslateQuantity = 0;
    const translateBtns = s.root.querySelectorAll('.le-side-date__controller-btn');
    translateBtns.forEach(btn => {
      const regExpResult = /_(up|down)/.exec(btn.className);
      const direction = regExpResult[1];
      btn.addEventListener('click', () => {
        clickTranslateAction(direction)
          .then(() => {
            switchVisibledBtnState();
          })
          .catch(() => {});
      })
    })

    if (s.isSp) {
      s.isTouch = false;
      bindSpSliderAction();
    }

    setCurrentSchedulePos();
    switchVisibledBtnState();
  }

  const bindSpSliderAction = () => {
    s.dateList.addEventListener('touchstart', () => {
      if (!s.isTouch) {
        const offsetPos = s.dateList[s.settings.offsetPos];
        s.dateList.style.left = '';
        s.root.scrollTo(offsetPos * -1, 0);
        s.isTouch = true;
        s.isSlide = false;
        s.oldOffsetPos = s.root.scrollLeft;
      }
    })
    s.oldOffsetPos = 0;
    s.root.addEventListener('scroll', () => {
      if (s.isTouch) {
        s.translateDir = s.oldOffsetPos - s.root.scrollLeft >= 0
          ? 'up'
          : 'down';
        switchVisibledBtnState();
        s.oldOffsetPos = s.root.scrollLeft;
      }
    })
  }

  const clickTranslateAction = (dir) => {
    return new Promise((resolve, reject) => {
      s.translateDir = dir;
      if (s.isSp && s.isTouch) {
        const translateScrollLeft = s.root.scrollLeft;
        s.dateList.classList.add('no-anim');
        s.root.scrollTo(0, 0);
        s.dateList.style[s.settings.translateParam] = `${translateScrollLeft * -1}px`;
        s.addTranslateQuantity = ((s.root.scrollLeft == 0 ? 0 : s.translateQuantity) - (translateScrollLeft % s.translateQuantity)) * (dir == 'up' ? -1 : 1);
        s.dateList.classList.remove('no-anim');
      }
      s.isSlide = true;
      s.isTouch = false;
      if (isScrollStop()) {
        reject();
        return;
      }
      const translateDistance = s.dateList[s.settings.offsetPos] - ((s.translateQuantity + s.addTranslateQuantity) * (dir == 'up' ? -1 : 1));
      s.addTranslateQuantity = 0;
      s.dateList.style[s.settings.translateParam] = `${translateDistance}px`;
      s.dateList.addEventListener('transitionend', () => {
        resolve();
      }, {
        once: true
      })
    })
  }
  const isScrollStop = () => {
    return isFitTopLeft() || isFitBottomRight();
  }
  const isFitTopLeft = () => {
    // console.log(s.translateDir, s.isTouch, s.root.scrollLeft);
    return s.translateDir == 'up' &&
      (
        (s.dateList[s.settings.offsetPos] >= 0 && s.isSlide)
        || (s.root.scrollLeft == 0 && s.isTouch)
      );
  }
  const isFitBottomRight = () => {
    return s.translateDir == 'down' &&
      (
        (s.dateList[s.settings.entityLength] - s.root[s.settings.clientLength]) + s.dateList[s.settings.offsetPos] < 0 && s.isSlide)
        || ((s.dateList[s.settings.entityLength] - s.root[s.settings.clientLength]) == s.root.scrollLeft && s.isTouch);
  }
  const switchVisibledBtnState = () => {
    s.root.classList.remove('is-hidden-top', 'is-hidden-bottom');
    if (isFitTopLeft()) {
      s.root.classList.add('is-hidden-top');
    }
    if (isFitBottomRight()) {
      s.root.classList.add('is-hidden-bottom');
    }
  }
  const setCurrentSchedulePos = () => {
    if (!s.isSp) {
      return;
    }
    const currentSchedule = s.root.querySelector('.is-current');
    const leftPos = currentSchedule.getBoundingClientRect().left;
    if ((window.innerWidth - currentSchedule.clientWidth) / 2 < leftPos) {
      s.translateDir = 'down';
      s.isTouch = true;
      s.root.scrollLeft = leftPos - ((window.innerWidth - currentSchedule.clientWidth) / 2);
    }
  }

  init();
}
